namespace $.$$ {
	export class $eve_app_page_design extends $.$eve_app_page_design {}
}
